import * as React from 'react';
import { Abo } from '../../api/Abo';
import { IAbo } from '../../api/model/IAbo';
import { AboList } from './AboList';
import { PrimaryButton } from '@fluentui/react/lib/Button';
import { Label } from '@fluentui/react/lib/Label';
import { Spinner } from '@fluentui/react/lib/Spinner';
import { showMessage } from '../../service/globalState.service';
const { useState, useEffect } = React;

interface AbsenceListProps {
  filter: (abos: IAbo[]) => IAbo[];
  absenceProjectFilter: string;
}

export const AbsenceList: React.FC<AbsenceListProps> = ({ filter, absenceProjectFilter }) => {
  const [abos, setAbos] = useState<IAbo[]>([]);
  const [showLoadMore, setShowLoadMore] = useState(true);
  const [spinner, showSpinner] = useState(false);

  useEffect(() => {
    requestAbos();
  }, [])

  const cutoff = 50;

  // const isFiltered = (abo: IAbo): boolean => {
  //   if (!filter) return true;
  //   const lowerFilter = filter.toLowerCase();
  //   const { ProjectName, TaskName } = abo;
  //   return ProjectName.toLowerCase().includes(lowerFilter) || TaskName.toLowerCase().includes(lowerFilter);
  // }

  const requestAbos = async () => {
    showSpinner(true);
    try {
      const absenceQuery = `$filter=contains(ProjectName,'${absenceProjectFilter}')&$orderby=EndDate desc&$top=${cutoff}&$skip=${abos.length}`;
      const abosRes = await Abo.getAll(absenceQuery);

      setShowLoadMore(abosRes.length >= cutoff);
      setAbos(abos.concat(abosRes));
    } catch (e) {
      showMessage({
        type: "error",
        text: 'Error while loading tasks: ' + JSON.stringify(e)
      });
    }
    showSpinner(false);
  }
  return (
    <>
      <Label disabled>
        Ordered by end date descending
      </Label>

      <AboList abos={filter(abos)} />

      {spinner && <Spinner />}

      {showLoadMore && (
        <div style={{ textAlign: 'center' }}>
          <br />
          <PrimaryButton
            text='Load older tasks'
            onClick={requestAbos}
          />
        </div>
      )}
    </>
  )
}